import { Router } from '@angular/router';
import { AuthMessage } from './models/auth-message';
import { Access } from './models/access';
import { EventTypes } from './../shared/EventTypes';
import { AutenticationService } from './autentication.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input } from '@angular/core';
import { TweenMax, Quint, Sine } from 'gsap';
import { AppEventDispatcher } from '../utils/AppEventDispatcher';
import { AutenticationEventType } from './autentication.event.type';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { AppConfig } from '../AppConfig';
import { Auth } from './Auth';
import * as moment from 'moment';
import { User } from './models/user';
import { ThemeService } from '../shared/theme-service/theme.service';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-autentication',
	templateUrl: './autentication.component.html',
	styleUrls: ['./autentication.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class AutenticationComponent implements OnInit, OnDestroy {
	@Input() loading = true;

	corBotaoDesabilitado: any;
	slideConfig = { 'slidesToShow' : 1, arrows: false, dots: true, autoplay: true, autoplaySpeed: 3000 };
	hasCookie = false;
	disabled = false;
	modalHidden = true;
	modalHiddenNewYear = true;
	isOpenBank: boolean;
	isAttendant = false;
	fraseInicial1: string;
	fraseInicial2: string;
	phoneCrCapital = '4004 3500';
	phoneCrMore = '0800 701 3500';

	constructor(
		private router: Router,
		private authService: AutenticationService,
		private themeService: ThemeService,
		private titleService: Title) {
		this.titleService.setTitle("Login Área do Cliente | Omni");
		}

	ngOnInit() {
		this.authService.generateGUID();

		this.authService.auth().subscribe(data => {
			this.getAuthConfigurations();
		});

		addEventListener('mousedown', this.recordActivity, false);
		addEventListener('mousemove', this.recordActivity, false);
		addEventListener('keydown', this.recordActivity, false);
		addEventListener('scroll', this.recordActivity, false);
	}

	private checkSessionTimeout() {
		if (this.router.url != '/login') {
			console.log('checkSessionTimeout');
			const auth = Auth.getInstance();
			const lastAct = auth.getLastActivity();
			console.log(lastAct)
			if (lastAct.add(AppConfig.sessionTime, 'minutes') < moment()) {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Sessão encerrada devido a inatividade, efetue o login novamente para continuar' });
				Auth.getInstance().logout();
				this.router.navigate(['login']);
				AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.LOADER, { show: false });
			}
		}
	}

	private getAuthConfigurations() {
		this.authService.getConfig().subscribe((config: any) => {

			AppConfig.passwordTry = config.Retorno.QuantidadeErroLogin;
			AppConfig.blockedTime = config.Retorno.TempoErroLogin;
			AppConfig.smsTry = config.Retorno.QuantidadeErroSms;
			AppConfig.sessionTime = 15;

			Auth.getInstance().unblockLogin();


			this.themeService.fetchThemeConfigs(true).subscribe((config: any) => {
				this.isOpenBank = this.themeService.isOpenBank();
				this.definePhonesByTheme();
			});

			if (this.themeService.themeConfigs) {
				this.fraseInicial1 = this.themeService.FraseInicial1 ? this.themeService.FraseInicial1 : '';
				this.fraseInicial2 = this.themeService.FraseInicial2 ? this.themeService.FraseInicial2 : '';

				this.corBotaoDesabilitado = this.themeService.CorBotaoDesabilitado ? this.themeService.CorBotaoDesabilitado : '';
			}

			this.isAttendant = this.themeService.isAttendant();

			if (this.isAttendant) {
				this.show(() => {
					this.loading = false;
					AppEventDispatcher.dispatch(AutenticationEventType.ATTENDANT.ATTENDANT_AUTH, { delay: 0 });
				});

			} else {
				this.show(() => { this.checkCookie(); });
			}
		}, error => {
			this.show((data) => {
				this.checkError(error);
			});
		}, () => {
			this.checkSessionTimeout();
		});

		AppEventDispatcher.listen(AutenticationEventType.LOGIN.LOGIN, () => {
			this.login();
		});
	}

	definePhonesByTheme() {
		switch (this.themeService.currentURL) {
			case 'engehall':
				this.phoneCrCapital = '4003 0583';
				this.phoneCrMore = '0800 770 6301';
				break;
		}
	}

	recordActivity() {
		Auth.getInstance().recordLastActivity(moment());
	}

	ngOnDestroy() {
		this.titleService.setTitle("Omni Banco S/A");
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.LOGIN);
	}

	show(handler) {
		if (window.innerWidth > 991) {
			TweenMax.to('[data-component="autentication"] .container-abs', 1, {delay: 1, top: '45%', ease: Quint.easeOut, onComplete: () => {
				handler();
			}});
		} else {
			TweenMax.to('[data-component="autentication"] .container-abs', 1, {
				delay: 1,
				top: '0%',
				ease: Quint.easeOut,
				onComplete: () => {
					TweenMax.set('[data-component="autentication"]', { overflowY: 'auto' });
					handler();
				}
			});
		}
	}

	checkCookie() {
		if (JSON.parse(Cookie.get('OmniAccountsList'))) {

			const cookieAccounts = JSON.parse(Cookie.get('OmniAccountsList'));

			const user: User = cookieAccounts['0'].user;

			Auth.cpf = user.cpf;

			this.hasCookie = true;

			this.authService.getUserByCpf(user.cpf).subscribe((access: Access) => {

				Auth.acceptTerms = access.acceptTerms;
				Auth.termsText = access.termsText;
				Auth.hasSecurityQuestions = access.hasSecurityQuestions;

				this.loading = false;

				if (access.exists) {
					if ( !Auth.acceptTerms ) {
						AppEventDispatcher.dispatch( EventTypes.TERMS.TERMS, { show: true, text: Auth.termsText, acceptHandler: this, access: access });
					}else {
						this.checkAfterTerms(access);
					}
				} else {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'CPF não encontrado' });
				}

			}, error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});

		} else {
			this.loading = false;
			AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.MY_CPF, {delay: 0});
		}
	}

	checkError(error) {
		if (error && error.error && error.error.Tipo) {
				if (error.error.Tipo === 'bloqueio') {
					const blockedDate = moment(error.error.ExpiracaoBloqueio).utc(true);

					if (blockedDate && moment().utc(true).isBefore(blockedDate)) {
						Auth.getInstance().blockLogin(moment(error.error.ExpiracaoBloqueio).utc(true));
						AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.PASS_MONITOR_BLOCKED, {delay: 0});
					}

				}
		}

	}

	changeToLoginScene() {
		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.USER_AND_PASS, {delay: .2});
	}

	changeToDefinePassword() {

		Auth.definePassword = true;

		TweenMax.to('[data-component="login"]', .8, { width: '100%', ease: Sine.easeOut});
		TweenMax.to('[data-component="login"] .logo', .8, { scale: .85, top: 25, ease: Sine.easeOut});

		const message = new AuthMessage();
		message.buttonTitle = 'Continuar';
		message.delay = .2;
		message.eventToDispatch = AutenticationEventType.LOGIN.SECURITY_CHECK;
		message.eventData = { show: true };
		message.hasButton = true;
		message.title = 'Olá, vamos definir sua senha?';
		message.text = 'Vamos te ajudar a defini-la, é fácil e rápido. Vamos lá?';
		message.withPreload = true;

		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);
	}

	changeToRedefinePassword() {

		Auth.definePassword = false;

		TweenMax.to('[data-component="login"]', .8, { width: '100%', ease: Sine.easeOut});
		TweenMax.to('[data-component="login"] .logo', .8, { scale: .85, top: 25, ease: Sine.easeOut});

		const message = new AuthMessage();
		message.buttonTitle = 'Continuar';
		message.delay = .2;
		message.eventToDispatch = AutenticationEventType.LOGIN.SECURITY_CHECK;
		message.eventData = { show: true };
		message.hasButton = true;
		message.title = 'Olá, vamos redefinir sua senha?';
		message.text = 'Vamos te ajudar a redefini-la, é fácil e rápido. Vamos lá?';
		message.withPreload = true;

		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);

	}

	login() {
		this.authService.loadAccounts(Auth.cpf, Auth.tempPass).subscribe( (data: any) => {

			this.hasLoged();

		}, error => {

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });

				const message = new AuthMessage();
				message.buttonTitle = 'Acessar';
				message.delay = .2;
				message.eventToDispatch = AutenticationEventType.LOGIN.LOGIN;
				message.eventData = null;
				message.delayToDispatchEvent = 0;
				message.hasButton = true;
				message.title = 'Sua senha foi definida com sucesso!';
				message.text = 'A partir de agora, esta será a sua senha para acessar a sua conta.';
				message.withPreload = true;
					this.disabled = false;

				AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.AUTH_MESSAGE, message);

			});
	}

	hasLoged() {

		if (Auth.getInstance().getAccountsList().length > 1 && !this.hasCookie) {

			AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.ACCOUNTS_LIST, {delay: .2});
			AppEventDispatcher.dispatch(AutenticationEventType.AUTH_MESSAGE.LOAD_COMPLETE, null);

		} else if (Auth.getInstance().getAccountsList().length > 0) {

			// Configura a única conta e usuário que existe e efetua o login
			const user: User = Auth.getInstance().getAccountsList()[0].user;
			user.rule = Auth.getInstance().getAccountsList()[0].rights;

			Auth.getInstance().setUser(user);

			this.authService.setAccount().subscribe( account => {
				this.checkAccessPix();
				if (!Auth.hasSecurityQuestions) {
					AppEventDispatcher.dispatch(AutenticationEventType.SECURITY_CHECK_REGISTRATION.INIT, { show: true });
				} else {
					this.router.navigate(['']);
				}
				AppEventDispatcher.dispatch(AutenticationEventType.AUTH_MESSAGE.LOAD_COMPLETE, null);
			}, error => {
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});
		}

		localStorage.setItem('isRegistrationModalViewed', 'false');

	}

	checkAccessPix() {
		this.authService.getPixAccessAvailable().subscribe(data => {
			if (data.Sucesso) {
				const user: User = Auth.getInstance().getUser();
				user.accessPix = data.Retorno;
				Auth.getInstance().setUser(user);
				AppEventDispatcher.dispatch(EventTypes.MENU.CHANGE, { show: true });
			}
		});
	}

	checkAfterTerms(access) {
		if ( access.hasPassAccess && access.hasPassTransaction && access.exists ) {
			this.changeToLoginScene();
		} else if (access.passAccessBlocked && access.exists) {
			this.changeToRedefinePassword();
		} else if (access.exists) {
			this.changeToDefinePassword();
		} else {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'CPF não encontrado' });
		}
	}
	openModalChannel() {
		this.modalHidden = false;

		TweenMax.to('.container-abs .modal-channels', .5, {
			opacity: 1,
			autoAlpha: 1,
			bottom: '0%',
			ease: Quint.easeOut
		});
	}

	closeModalChannel() {
		TweenMax.to('.container-abs .modal-channels', .5, {
			opacity: 0,
			autoAlpha: 0,
			bottom: '-50%',
			ease: Quint.easeOut,
			onComplete: () => {
				this.modalHidden = true;
			}
		});
	}

	openModalChannelNewYear() {
		this.modalHiddenNewYear = false;

		TweenMax.to('.container-abs .modal-channels-new-year', .5, {
			opacity: 1,
			autoAlpha: 1,
			bottom: '0%',
			ease: Quint.easeOut
		});
	}

	closeModalChannelNewYear() {
		TweenMax.to('.container-abs .modal-channels-new-year', .5, {
			opacity: 0,
			autoAlpha: 0,
			bottom: '-50%',
			ease: Quint.easeOut,
			onComplete: () => {
				this.modalHiddenNewYear = true;
			}
		});
	}
}





// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/autentication.component.ts